import React from "react";
import styles from "./index.module.scss";
import NothingList from "../../components/nothingList";

interface IShop {
  code: string;
  distance: number;
  linkAddr: string;
  isUserDefaultShop: number;
  name: string;
}

interface IProps {
  allShopList: IShop[];
  tip: string;
  selectedShop: IShop;
  onSelectShop: (item) => void;
}

export default function ActionSheet({
  allShopList,
  tip,
  selectedShop,
  onSelectShop,
}: IProps) {
  return (
    <div className={styles.pickShopContainer}>
      <h3 className={styles.title}>可选门店</h3>
      {allShopList?.length > 0 ? (
        <div>
          <div>
            {allShopList.map((item) => {
              return (
                <div className={styles.shopItem} key={item.code}>
                  <div
                    className={styles.baseInfo}
                    onClick={() => onSelectShop(item)}
                  >
                    <div
                      className={[
                        styles.radio,
                        item.code === selectedShop?.code ? styles.selected : "",
                      ].join(" ")}
                    ></div>
                    <div className={styles.shopInfo}>
                      <div className={styles.shopTitle}>
                        <h3 className={styles.titleTxt}>{item.name}</h3>
                        {item.distance >= 0 ? (
                          <h3 className={styles.distanceTxt}>
                            距您 {item.distance} km
                          </h3>
                        ) : null}
                      </div>
                      <p className={styles.address}>
                        <span>{item.linkAddr}</span>
                      </p>
                      <div className={styles.tags}>
                        {item.isUserDefaultShop === 1 ? (
                          <div className={styles.yellowTag}>专属门店</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <NothingList tip={tip} />
      )}
    </div>
  );
}
